import { render, staticRenderFns } from "./OperarioIndex.vue?vue&type=template&id=ebd84904"
import script from "./OperarioIndex.vue?vue&type=script&lang=js"
export * from "./OperarioIndex.vue?vue&type=script&lang=js"
import style0 from "./OperarioIndex.vue?vue&type=style&index=0&id=ebd84904&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports